import { Message } from 'element-ui'

const $message = options => {
  return Message({
    ...options,
    center: true,
    duration: 5 * 1000
  })
}

// 重写方法
['success', 'warning', 'info', 'error'].forEach(type => {
  $message[type] = options => {
    if (typeof options === 'string') {
      options = {
        message: options,
        center: true,
        // duration: 0,
        duration: 5 * 1000
      }
    }
    options.type = type
    return Message(options)
  }
})

export default $message
